export const pghvDataSources = [
  {
    title: 'Training acceleration – GIS & GCB SharePoint',
    content:
      'The training related information from the Hitachi Energy GIS & GCB Training center easily accessible through Akira – Hitachi Energy Gen AI platform. The goal is to help employees quickly find answers to common training related questions, such as certification requirements, course schedule and cancellation policies, by querying Akira instead of manually searching through sharepoint.',
    sourceSystem: null,
    prompts: [
      'How do I cancel or postpone training enrollments?',
      'How do I get certified on Level 3 ST-GIS?',
      'What are the requirements to grant GIS re-certification?'
    ],
    datasourcelink: '',
    contact: 'gis-gcb_training@hitachienergy.com'
  },
  {
    title: 'Global Technical Communication Portal ',
    content:
      'The High Voltage (HV) business of Hitachi Energy provides critical equipment like GIS and circuit breakers to global customers. To support safe and efficient field operations, engineers need fast access to accurate technical documentation. Currently, content is scattered across systems, causing delays and errors. The “Training Acceleration – Technical Content” initiative organizes/manages the data, enabling instant access, improving training, reducing downtime, and ensuring compliance. With Akira integration, engineers benefit from intelligent search, contextual recommendations, and seamless access.',
    sourceSystem: null,
    prompts: ['How do I install a transversal installation unit on an ELK-04/145 kV?'],
    datasourcelink: '',
    contact: 'gis-gcb_training@hitachienergy.com'
  },
  {
    title: 'Training acceleration – Field Service Server',
    content:
      'The Field Server server sharepoint data source helps to support field service engineers in the GCB (Generator Circuit Breaker) domain by integrating their SharePoint-based document repository into Akira. This enables quick access to critical commissioning guides and service documentation, improving efficiency and reducing time spent searching for technical resources in the field.',
    sourceSystem: null,
    prompts: ['Where is the new GCB commissioning guide?', ' Where do I find the GMS commissioning guide?'],
    datasourcelink: '',
    contact: 'gis-gcb_training@hitachienergy.com'
  },
  {
    title: 'RCA records for Global GIS & GCB',
    content: `Close to 61'000 GIS and GCBs are installed worldwide, some of which underwent failures which are investigated in depth. These investigations and Root Cause Analysis (RCA) reports are consolidated and maintained in this database. Akira integration is available to gain insights into the findings, learn from experiences and benefit from an intelligent search with contextual recommendations. Due to confidentiality reasons, the references to individual reports are not provided.`,
    sourceSystem: null,
    prompts: [
      'What are the major failure mechanism which leads in flashovers in ELK3 420s',
      'What preventive measures are normally taken in case of major failure in ELK 4/ 145',
      'What was the root cause of earthing switch failure'
    ],
    datasourcelink: '',
    feedback: true
  },
  {
    title: 'Global Product Failure Database  (GPFD)',
    content: `Global Product Failure Database contains structured data of 175'000 installed HV products (GIS, GCB, DTB, IT) with a cumulated bay years' experience of more than 1.5 million years. As there is a substantial know how in this data, the aim of Akira integration is to provide a quick and easy access to users globally through natural language queries - transforming complex data into intuitive, actionable intelligence.`,
    sourceSystem: null,
    prompts: [
      'Among the ELK - 04 / 145 produced between 2005 until 2020 what were the major 5 defect types?',
      'Which is the major failure contributor interms of frequency of failures in ELK-04/170?',
      'Which country has the highest gas leakage failures?'
    ],
    datasourcelink: '',
    feedback: true
  },
  {
    title: 'HVPLM GIS Product documentation',
    content: `(HV_GIS_Product Documentation) supports global product teams by enabling easy access to critical GIS technical documents—such as operational manuals, test instructions, and technical reports—stored in the HVPLM system. With Akira’s AI-powered search, users can quickly retrieve relevant information using simple queries. This helps improve service efficiency, speed up training, and support better decision-making. By making key documentation easily accessible, Akira ensures that GIS employees have the right information at the right time, without needing to manually search through complex systems.`,
    sourceSystem: null,
    prompts: [
      'what is the difference between a Delivery and Test Instruction (DiTi or DITI or Di/Ti) and a Component Supply Specification (CSS) or Internal Test Specification (ITS)?',
      'How is the BAC tested during production?',
      'How do I create a BOM for a new GIS?'
    ],
    datasourcelink: '',
    feedback: true
  }
]
